module.exports = __webpack_public_path__ + "static/media/app2.4e037969.png";